var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Social/Instagram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0H5C2.239 0 0 2.2474 0 5.01875V11.0412C0 13.8126 2.239 16.06 5 16.06H11C13.761 16.06 16 13.8126 16 11.0412V5.01875C16 2.2474 13.761 0 11 0ZM4 8.03C4 5.81272 5.791 4.015 8 4.015C10.209 4.015 12 5.81272 12 8.03C12 10.2473 10.209 12.045 8 12.045C5.791 12.045 4 10.2473 4 8.03ZM5.5 8.03041C5.5 9.41357 6.622 10.5398 8 10.5398C9.378 10.5398 10.5 9.41357 10.5 8.03041C10.5 6.64623 9.378 5.52103 8 5.52103C6.622 5.52103 5.5 6.64623 5.5 8.03041ZM12.8331 3.71387C12.8331 4.00934 12.5945 4.24887 12.3001 4.24887C12.0057 4.24887 11.7671 4.00934 11.7671 3.71387C11.7671 3.4184 12.0057 3.17887 12.3001 3.17887C12.5945 3.17887 12.8331 3.4184 12.8331 3.71387Z",
    fill: "#5F5F60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.ab117d5176e40c6d8c66623a275c7c24.svg";
export { ForwardRef as ReactComponent };